
export class NameDTO {
    fullName: string;
    firstName: string;
    lastName: string;
}